import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "opColorPicker",
  ref: "root"
}
const _hoisted_2 = ["disabled", "title"]
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "d-flex align-items-center gap-2 mt-2" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "small font-monospace",
  style: {"width":"38px","text-align":"right"}
}
const _hoisted_8 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_9 = ["onClick", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "opColorSwatch",
      ref: "swatch",
      disabled: _ctx.disabled,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      title: _ctx.css
    }, [
      _createElementVNode("span", {
        style: _normalizeStyle({ background: _ctx.css })
      }, null, 4)
    ], 8, _hoisted_2),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "opColorBackdrop",
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          onWheel: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          onContextmenu: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }, null, 32))
      : _createCommentVNode("", true),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "opColorPopover shadow",
          ref: "popover",
          style: _normalizeStyle(_ctx.popoverStyle)
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              type: "color",
              class: "form-control form-control-color form-control-sm flex-shrink-0",
              value: _ctx.hex6,
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onHueInput && _ctx.onHueInput(...args))),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.commit && _ctx.commit(...args))),
              title: "Colore"
            }, null, 40, _hoisted_4),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm font-monospace",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.text) = $event)),
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onTextChange && _ctx.onTextChange(...args))),
              onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onTextChange && _ctx.onTextChange(...args)), ["prevent"]), ["enter"])),
              placeholder: "#rrggbb o rgba()"
            }, null, 544), [
              [_vModelText, _ctx.text]
            ]),
            (_ctx.hasEyeDropper)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline-secondary btn-sm flex-shrink-0",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.pickFromScreen && _ctx.pickFromScreen(...args))),
                  title: "Prendi un colore dallo schermo"
                }, "⌖"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "small text-muted" }, "Opacità", -1)),
            _createElementVNode("input", {
              type: "range",
              class: "form-range flex-grow-1",
              min: "0",
              max: "100",
              step: "1",
              value: _ctx.alphaPct,
              onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onAlphaInput && _ctx.onAlphaInput(...args))),
              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.commit && _ctx.commit(...args))),
              style: _normalizeStyle(_ctx.alphaTrackStyle)
            }, null, 44, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.alphaPct) + "%", 1)
          ]),
          (_ctx.paletteColors.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "small text-muted mt-2 mb-1" }, "Colori del template", -1)),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paletteColors, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c,
                      type: "button",
                      class: _normalizeClass(["opColorSwatch small", { current: c == _ctx.css }]),
                      onClick: ($event: any) => (_ctx.choose(c)),
                      title: c
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ background: c })
                      }, null, 4)
                    ], 10, _hoisted_9))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true)
  ], 512))
}